export const TYPES = {
  OfflineDetectionService: Symbol('offline/OfflineDetectionService'),
  DownloadCaseForOfflineUseCase: Symbol('offline/DownloadCaseForOfflineUseCase'),
  OfflineDB: Symbol('offline/OfflineDB'),
  OfflineUtilsService: Symbol('offline/OfflineUtilsService'),
  DownloadForOfflineButtonController: Symbol('offline/DownloadForOfflineButtonController')
};
